import {
  List,
  ListItemButton,
  ListItemText,
  alpha,
  styled,
} from '@mui/material';
import { Link } from 'react-router-dom';

export const StyledList = styled(List)(({ theme }) => ({
  width: '198px',
  alignItems: 'center',
  backgroundColor: theme.palette.background.quaternary,
  borderRadius: '16px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(1),
  margin: 1,
  boxShadow: `0px 64px 64px -32px ${alpha(theme.palette.background.quaternary, 0.56)}`,
  border: `0.5px solid ${alpha(theme.palette.primary.main, 0.3)}`,
}));

export const StyledItemButton = styled(ListItemButton)(({ theme }) => ({
  padding: theme.spacing(5, 6, 5, 5),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  borderRadius: 'inherit',
  '& svg': {
    width: '20px',
    height: '20px',
  },
}));

export const StyledItemText = styled(ListItemText)({
  textAlign: 'right',
  margin: 0,
});

export const StyledLink = styled(Link)(({ theme }) => ({
  textDecoration: 'none',
  width: '100%',
  borderRadius: '12px',
  color: alpha(theme.palette.primary.light, 0.7),
  fontSize: theme.typography.textSm.fontSize,
  fontWeight: 400,
  transitionProperty: 'color, background',
  transitionDuration: '0.2s',
  transitionTimingFunction: 'linear',
  '&:hover': {
    fontWeight: 500,
    color: theme.palette.primary.main,
    background: alpha(theme.palette.primary.main, 0.06),
  },
  '&:active': {
    background: theme.palette.background.main,
    color: theme.palette.background.secondary,
  },
}));
